/* eslint-disable */
/* tslint:disable */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  NgZone,
  TemplateRef,
} from '@angular/core';
import { ProxyCmp, proxyOutputs } from '../angular-component-lib/utils';
import { Components } from '@bkkr/core';

export declare interface BkkrPopover extends Components.BkkrPopover {
  /**
   * Emitted after the popover has presented.
   **/
  bkkrPopoverDidPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the popover has presented.
   */
  bkkrPopoverWillPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the popover has dismissed.
   */
  bkkrPopoverWillDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the popover has dismissed.
   */
  bkkrPopoverDidDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the popover has presented. Shorthand for bkkrPopoverWillDismiss.
   */
  didPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the popover has presented. Shorthand for bkkrPopoverWillPresent.
   */
  willPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the popover has dismissed. Shorthand for bkkrPopoverWillDismiss.
   */
  willDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the popover has dismissed. Shorthand for bkkrPopoverDidDismiss.
   */
  didDismiss: EventEmitter<CustomEvent>;
}

@ProxyCmp({
  inputs: [
    'alignment',
    'animated',
    'arrow',
    'backdropDismiss',
    'cssClass',
    'dismissOnSelect',
    'enterAnimation',
    'event',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'showBackdrop',
    'trigger',
    'triggerAction',
    'reference',
    'size',
    'side',
  ],
  methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss'],
})
@Component({
  selector: 'bkkr-popover',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-container [ngTemplateOutlet]="template" *ngIf="isCmpOpen || keepContentsMounted"></ng-container>`,
  inputs: [
    'alignment',
    'animated',
    'arrow',
    'backdropDismiss',
    'cssClass',
    'dismissOnSelect',
    'enterAnimation',
    'event',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'showBackdrop',
    'trigger',
    'triggerAction',
    'reference',
    'size',
    'side',
  ],
})
export class BkkrPopover {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  isCmpOpen: boolean = false;

  protected el: HTMLElement;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    this.el = r.nativeElement;

    this.el.addEventListener('bkkrMount', () => {
      this.isCmpOpen = true;
      c.detectChanges();
    });
    this.el.addEventListener('didDismiss', () => {
      this.isCmpOpen = false;
      c.detectChanges();
    });

    proxyOutputs(this, this.el, [
      'bkkrPopoverDidPresent',
      'bkkrPopoverWillPresent',
      'bkkrPopoverWillDismiss',
      'bkkrPopoverDidDismiss',
      'didPresent',
      'willPresent',
      'willDismiss',
      'didDismiss',
    ]);
  }
}
